import { render } from "./PassengerDetailsFieldset.vue?vue&type=template&id=cb8bbf00&scoped=true&lang=pug"
import script from "./PassengerDetailsFieldset.vue?vue&type=script&lang=ts"
export * from "./PassengerDetailsFieldset.vue?vue&type=script&lang=ts"

import "./PassengerDetailsFieldset.vue?vue&type=style&index=0&id=cb8bbf00&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb8bbf00"

export default script